import { CallOffOrderDetail } from '@ravago/shared/page-data/models/elements';

import { useQuery } from '@tanstack/react-query';

import { getCallOffOrderDetail } from '../call-off-order.utils';
import { getContentfulProductsByIds } from '../order-product.utils';

interface UseCallOffOrderDetailParams {
  callOffId: string | undefined;
  locale: string;
  enabled?: boolean;
}

export const useCallOffOrderDetail = ({ callOffId, locale, enabled = true }: UseCallOffOrderDetailParams) => {
  const {
    data: callOffOrderDetail,
    isLoading,
    error
  } = useQuery({
    queryKey: ['callOffOrderDetail', callOffId, locale],
    queryFn: async (): Promise<CallOffOrderDetail | undefined> => {
      if (!callOffId) return undefined;

      const callOffOrder = await getCallOffOrderDetail(callOffId);
      if (!callOffOrder) return undefined;

      // Fetch contentful product if pkbId exists
      if (callOffOrder.product.pkbId) {
        try {
          const contentfulProductResponse = await getContentfulProductsByIds(locale, [`product-${callOffOrder.product.pkbId}`]);
          callOffOrder.contentfulProduct = contentfulProductResponse?.length ? contentfulProductResponse[0] : undefined;
        } catch {
          callOffOrder.contentfulProduct = undefined;
        }
      }

      return callOffOrder;
    },
    enabled: !!callOffId && enabled
  });

  return {
    callOffOrderDetail,
    isLoading,
    error
  };
};
